<template>
    <div class="contain">
        <HeaderMenu></HeaderMenu>
        <div class="main">
            <div class="headline-title">
                <div class="headline-title-content">
                    LINENAZI
                </div>
            </div>
            <div class="app-menu">
                <ProductBox></ProductBox>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderMenu from '@/components/HeaderMenu.vue';
import ProductBox from '@/components/ProductBox.vue';
export default {
    data() {
        return {

        }
    },
    beforeCreate() {

    },
    mounted() {
    },
    components: { HeaderMenu, ProductBox }
}
</script>

<style scoped>
.contain {
    z-index: 1;
    background-image: url(@/assets/登录炫彩模糊背景.png);
}
.main {
    box-sizing: border-box;
    padding: 20px;
    min-height: calc(100vh - 60px);
    text-align: center;
}

.headline-title {
    margin: 40px auto;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0 20px;
    margin-bottom: 40px;
}

.headline-title-content {
    font-size: 120px;
    background-image: url("./../assets/title.gif");
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    font-family: "title";
    font-weight: bolder;
}

.app-menu {
    width: 1120px;
    margin: 0 auto;
}
</style>